import axios from "axios";
import React, { useEffect, useState } from "react";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
import moment from "moment";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import * as XLSX from "xlsx";
import {
  SUMMARY_REPORT_DAYWISE,
  SUMMARY_REPORT_DAYWISE_EXCEL,
  FETCH_SYSTEM_IDS,
  FETCH_SENDER_IDS,
  SMS_CAMPEIGN_HISTORY,
  SMS_CAMPEIGN_EXCEL,
  SMS_TMPLTS_SNDRIDS,
  CLIENT_BY_ID,
  CHANNEL_CLIENT_CHNLTYPE,
} from "../../constants";

import * as FileSaver from "file-saver";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import { invalid } from "moment/moment";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";
import apiService from "../../variables/apiService";

let templates = [];
let senderids = [];
let systemids = [];

var initialvalues = {
  fromdate: "",
  todate: "",
  templateid: "",
  senderid: "",
  systemid: "",
};

const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson);
const Reportssms = () => {
  var totlsent = 0;
  var totldeliver = 0;
  var totlfail = 0;

  const [horizontalTabs, sethorizontalTabs] = React.useState("summaryreports");
  const [search, setSearch] = useState(initialvalues);
  const [errorhandle, setErrorHandle] = useState();
  const [isLoading, setIsLoading] = React.useState(false);

  const [campignData, setCampaignData] = useState({
    campignfromdate: new Date(),
    campigntodate: new Date(),
  });
  const [campignvalidate, setCampaignValidate] = useState({
    campignmessage: "",
    campignnotValid: false,
  });
  const [smsdata, setSmsdata] = useState();
  const [campaigin, setCampaign] = useState([]);

  const [channel, setChannel] = useState([]);
  const notificationAlertRef = React.useRef(null);

  useEffect(() => {
    fetchChanelsbyClient();
    getSenderidsByClient();
    getSystemidsByClient();
  }, []);

  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "sms",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          templates = [{ value: "0", label: "Select All" }];

          setChannel(res?.data);

          res?.data?.map((item, i) => {
            item?.template &&
              templates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  //fetch senderid by client
  const getSenderidsByClient = () => {
    //clintId:user?.client
    senderids = [];
    const payload = {
      client_id: user?.client.toString(),
    };
    // senderids.push({label:senderid[i],value:senderid[i]})
    apiService
      .postData(FETCH_SENDER_IDS, payload)
      .then((res) => {
        res?.data?.message?.map((item, key) => {
          const senderid = item?.senderid?.split(",");
          for (let i = 0; i < senderid?.length; i++) {
            senderid[i] &&
              senderids.push({ label: senderid[i], value: senderid[i] });
          }
          // senderids.push({label:item?.senderid,value:item?.senderid})
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  //fetch System ids by client
  const getSystemidsByClient = () => {
    //clintId:user?.client
    systemids = [];
    const payload = {
      client_id: user?.client.toString(),
    };
    // senderids.push({label:senderid[i],value:senderid[i]})
    apiService
      .postData(FETCH_SYSTEM_IDS, payload)
      .then((res) => {
        res?.data?.message?.map((item, key) => {
          const system_id = item?.system_id?.split(",");
          for (let i = 0; i < system_id?.length; i++) {
            system_id[i] &&
              systemids.push({ label: system_id[i], value: system_id[i] });
          }

          // res?.data?.message?.map((item,key)=>{
          //   item?.system_id&&systemids.push({label:item?.system_id,value:item?.system_id})
          // })
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const changeSender = (data) => {
    senderids = [];
    const chnl = channel?.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setSearch((prev) => ({ ...prev, templateid: data, senderid: "" }));
  };

  const submitHandler = async () => {
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    let senderid = search?.senderid?.value || user?.sender_id || "";
    let templateid = search?.templateid?.value || "";
    let client_id = user?.client?.toString();
    //let system_id = user?.systemid;
    let system_id = search?.systemid?.value || user?.systemid || "";	
    //let systemid = "LH_APCPDCL"
    const isvalidate = validate();

    setErrorHandle(isvalidate);
    if (Object.keys(isvalidate).length == 0) {
      setIsLoading(true);
      await apiService
        .postData(SUMMARY_REPORT_DAYWISE, {
          fromdate: fromdate,
          todate: todate,
          senderid: senderid,
          templateid: templateid,
          client_id: client_id,
          user_id: system_id,
        })
        .then((res) => {
          setSmsdata(res.data);
          setIsLoading(false);
          console.log(res);
        })
        .catch((err) => {
          setIsLoading(false);
          setSmsdata([]);
          console.log("error====>", err);
        });
    }
  };

  const validate = () => {
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");

    let errors = {};
    //   if(search?.templateid?.value!==0){
    //   if(!search?.templateid?.value){
    //     errors.templateid="Please Select Template"
    //   }
    //   if(!search?.senderid?.value){
    //     errors.senderid="Please Select Sender Id"
    //   }
    // }
    if (!search.fromdate) {
      errors.fromdate = "Please Select From Date";
    }
    if (!search.todate) {
      errors.todate = "Please Select To Date";
    }

    if (todate < fromdate) {
      errors.todate = "To date should be greater than or equal to from date";
    }

    return errors;
  };
  const submitCampignHandler = async () => {
    let fromdate = moment(campignData.campignfromdate).format("YYYY-MM-DD");
    let todate = moment(campignData.campigntodate).format("YYYY-MM-DD");

    await apiService
      .postData(SMS_CAMPEIGN_HISTORY, { fromdate: fromdate, todate: todate })
      .then((res) => {
        setCampaign(res.data.data);
      
      })
      .catch((err) => {
        setCampaign([]);
        console.log("error====>", err)
      });
  };

  const changeActiveTab = (e, tabState, tabName) => {
    e.preventDefault();
    switch (tabState) {
      case "horizontalTabs":
        sethorizontalTabs(tabName);
        break;

      default:
        break;
    }
  };

  const generateExcel = async () => {
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    let senderid = search?.senderid?.value || user?.sender_id || "";
    let templateid = search.templateid.value;
    let client_id = user?.client?.toString();
    let system_id = search?.systemid?.value || user?.username?.toString();
    //let systemid = "LH_APCPDCL"
    const isvalidate = validate();
    setErrorHandle(isvalidate);
    await apiService
      .postData(SUMMARY_REPORT_DAYWISE_EXCEL, {
        fromdate: fromdate,
        todate: todate,
        senderid: senderid,
        templateid: templateid,
        client_id: client_id,
        user_id: system_id,
      })
      .then((res) => {
        const body = res.data.message;
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(body);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fromdate + fileExtension);
      })
      .catch((err) => console.log("error====>", err));
  };

  const generateCampaignExcel = async (name) => {
    let fromdate = moment(campignData.campignfromdate).format("YYYY-MM-DD");
    let todate = moment(campignData.campigntodate).format("YYYY-MM-DD");

    await apiService
      .postData(SMS_CAMPEIGN_EXCEL, {
        fromdate: fromdate,
        todate: todate,
        name: name,
      })
      .then((res) => {
        const body = res.data.data;
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(body);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fromdate + fileExtension);
      })
      .catch((err) => console.log("error====>", err));
  };

  const generateEXCEL = async (date) => {
    setIsLoading(true);

    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    let senderid = search?.senderid?.value || user?.sender_id || "";
    let templateid = search?.templateid?.value || "";
    let client_id = user?.client?.toString();
   // let system_id = search?.systemid?.value || user?.username?.toString();
   //let system_id = user?.systemid;
   let system_id = search?.systemid?.value || user?.systemid || "";

    await apiService
      .postData(SUMMARY_REPORT_DAYWISE, {
        fromdate: fromdate,
        todate: todate,
        senderid: senderid,
        templateid: templateid,
        client_id: client_id,
        user_id: system_id,
      })
      .then((res) => {
        setIsLoading(false);
        const body =
          res.data.message.length > 0 ? res.data.message : "No Records";

        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        const fileExtension = ".xlsx";
        const ws = XLSX?.utils?.json_to_sheet(body);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array",
        });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
          data,
          "Daywise Detailed Report " + todate + fileExtension
        );
      })
      .catch((err) => {
        let options = {};
        options = {
          place: "tr",
          message: err?.message,
          type: "warning",
          autoDismiss: 3,
        };
        notificationAlertRef?.current?.notificationAlert(options);
        setIsLoading(false);
        console.log("error====>", err.message);
      });
  };

  return (
    <>
      <div className="content">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <div className="row">
          <Col md="12">
            <Card>
              <CardBody>
                <Nav className="nav-pills-info" pills>
                  <NavItem>
                    <NavLink
                      data-toggle="tab"
                      href="#pablo"
                      className={
                        horizontalTabs === "summaryreports" ? "active" : ""
                      }
                      onClick={(e) =>
                        changeActiveTab(e, "horizontalTabs", "summaryreports")
                      }
                    >
                      Summary Reports
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      data-toggle="tab"
                      href="#pablo"
                      className={horizontalTabs === "campaignshistory" ? "active" : ""}
                      onClick={(e) =>
                        changeActiveTab(e, "horizontalTabs", "campaignshistory")
                      }
                    >
                      Campaigns History
                    </NavLink>
                  </NavItem> */}
                </Nav>
                <TabContent className="tab-space" activeTab={horizontalTabs}>
                  <TabPane tabId="summaryreports">
                    <Col lg="12" className="mb-2">
                      {/* <h3>Get Summary Reports</h3> */}
                      <Row>
                        <Col md="2" sm="12">
                          <p className="category">
                            From Date<suf style={{ color: "red" }}>*</suf>{" "}
                          </p>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date",
                            }}
                            closeOnSelect={true}
                            timeFormat={false}
                            value={search.fromdate}
                            onChange={(val) => {
                              setSearch({ ...search, fromdate: val._d });
                            }}
                          />
                          {errorhandle?.fromdate && (
                            <span style={{ color: "red" }}>
                              {errorhandle?.fromdate}
                            </span>
                          )}
                        </Col>
                        <Col md="2" sm="12">
                          <p className="category">
                            To Date<suf style={{ color: "red" }}>*</suf>{" "}
                          </p>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date",
                            }}
                            closeOnSelect={true}
                            timeFormat={false}
                            value={search.todate}
                            onChange={(val) => {
                              setSearch({ ...search, todate: val._d });
                            }}
                          />
                          {errorhandle?.todate && (
                            <span style={{ color: "red" }}>
                              {errorhandle?.todate}
                            </span>
                          )}
                        </Col>

                        <Col md="2" sm="12">
                          <p className="category">Select Template</p>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="templateSelect"
                            value={search.templateid}
                            onChange={(value) => changeSender(value)}
                            options={templates}
                            placeholder="Select"
                          />
                          {/* {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>} */}
                        </Col>
                        <Col md="2" sm="12">
                          <p className="category">Select Sender Id</p>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="senderSelect"
                            value={search?.senderid}
                            onChange={(value) =>
                              setSearch((prev) => ({
                                ...prev,
                                senderid: value,
                              }))
                            }
                            options={senderids}
                            placeholder="Select"
                          />
                          {/* {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}  */}
                        </Col>

                        <Col md="2" sm="12">
                          <p className="category">Select System Id</p>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="systemidSelect"
                            value={search?.systemid}
                            onChange={(value) =>
                              setSearch((prev) => ({
                                ...prev,
                                systemid: value,
                              }))
                            }
                            options={systemids}
                            placeholder="Select"
                          />
                          {/* {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}  */}
                        </Col>

                        <Col md="2" sm="12">
                          <Button
                            className="btn-icon btn btn-primary mt-4"
                            onClick={() => submitHandler()}
                          >
                            <i class="tim-icons icon-double-right"></i>
                          </Button>

                          <Button
                            className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                            color="primary"
                            data-placement="top"
                            id="tooltipexcel"
                            type="button"
                            onClick={() => generateExcel()}
                          >
                            <i className="tim-icons icon-cloud-download-93" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target="tooltipexcel"
                          >
                            Excel
                          </UncontrolledTooltip>
                          <Button
                            className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                            color="primary"
                            data-placement="top"
                            id="tootippdf"
                            type="button"
                            onClick={() => generateEXCEL()}
                          >
                            <i className="tim-icons icon-cloud-download-93" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target="tootippdf"
                          >
                            Over all Report
                          </UncontrolledTooltip>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12">
                      {smsdata?.message?.map((item, index) => {
                        totlsent += item.SENT;
                        totldeliver += item.DELIVERED;
                        totlfail += item.FAILED;
                      })}
                      <Row className=" reports_smsstyles text-center ml-0 mr-0">
                        <Col sm="6" lg="4">
                          <p>
                            Total Sent <span>{totlsent || 0}</span>{" "}
                          </p>
                        </Col>
                        <Col sm="6" lg="4">
                          <p>
                            Total Delivered <span>{totldeliver || 0}</span>{" "}
                          </p>
                        </Col>
                        <Col sm="6" lg="4">
                          <p>
                            Total Failed <span>{totlfail || 0}</span>{" "}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <CardBody>
                          <Table responsive striped className="pd-0">
                            <thead className="text-primary mb-0">
                              <tr>
                                <th>Date</th>
                                <th>SENT </th>
                                <th>DLIVERED</th>
                                <th>FAILED</th>
                              </tr>
                            </thead>
                            <tbody>
                              {smsdata?.message?.length > 0 ? (
                                smsdata?.message?.map((item, index) => {
                                  return (
                                    <tr>
                                      <td>
                                        {moment(item.DATE).format("YYYY-MM-DD")}
                                      </td>
                                      <td>{item.SENT}</td>
                                      <td>{item.DELIVERED}</td>
                                      <td>{item.FAILED}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={6}>
                                    <h5>No Records Found</h5>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </CardBody>
                      </Row>
                      {/* <Row className="pull-right mb-4">
                  <Pagination >
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Previous"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-left"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Next"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-right"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                  </Row> */}
                    </Col>
                  </TabPane>
                  <TabPane tabId="campaignshistory">
                    <Col lg="12">
                      {/* <h3>Select Campaigns</h3> */}
                      <Row>
                        <Col md="3" sm="12">
                          <p className="category">From Date</p>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date",
                            }}
                            closeOnSelect={true}
                            timeFormat={false}
                            initialValue={new Date()}
                            value={campignData.campignfromdate}
                            onChange={(val) => {
                              setCampaignData({
                                ...campignData,
                                campignfromdate: val._d,
                              });
                              setCampaignValidate({
                                campignmessage: "",
                                campignnotValid: false,
                              });
                            }}
                          />
                        </Col>
                        <Col md="3" sm="12">
                          <p className="category">To Date</p>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date",
                            }}
                            closeOnSelect={true}
                            timeFormat={false}
                            initialValue={new Date()}
                            value={campignData.campigntodate}
                            onChange={(val) => {
                              setCampaignData({
                                ...campignData,
                                campigntodate: val._d,
                              });
                              setCampaignValidate({
                                campignmessage: "",
                                campignnotValid: false,
                              });
                            }}
                          />
                        </Col>

                        <Col lg="4">
                          <Button
                            className="btn-icon btn btn-primary mt-4"
                            onClick={() => submitCampignHandler()}
                          >
                            <i class="tim-icons icon-double-right"></i>
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12">
                      <p className="blockquote blockquote-primary text-center ">
                        {campaigin?.length} Campaign/s found for dates between{" "}
                        {moment(campignData.campignfromdate).format(
                          "YYYY-MM-DD"
                        )}{" "}
                        00:00:00 to{" "}
                        {moment(campignData.campigntodate).format("YYYY-MM-DD")}{" "}
                        23:59:59
                      </p>
                    </Col>

                    <Col lg="12" className="campaignhistory-styles">
                      <Row>
                        {campaigin?.map((data, index) => {
                          return (
                            <Col lg="6" className="">
                              <Card>
                                <CardHeader>
                                  <Row>
                                    <Col lg="8">
                                      <h3 className="mb-0">
                                        {data.campign_name}
                                      </h3>
                                      {/* <p><span>Manual</span> - Dear parent Kindly</p> */}
                                    </Col>
                                    <Col lg="4">
                                      <Button
                                        className="btn-primary btn-simple btn-icon btn-round  btn-icon  pull-right"
                                        color="primary"
                                        data-placement="top"
                                        id="tooltipexcel"
                                        type="button"
                                        onClick={() =>
                                          generateCampaignExcel(
                                            data?.campign_name
                                          )
                                        }
                                      >
                                        <i className="tim-icons icon-cloud-download-93" />
                                      </Button>
                                      <UncontrolledTooltip
                                        delay={0}
                                        placement="top"
                                        target="tooltipexcel"
                                      >
                                        Excel
                                      </UncontrolledTooltip>
                                    </Col>
                                  </Row>
                                </CardHeader>
                                <CardBody>
                                  <Row>
                                    <Col lg="5">
                                      <Label className="label-headding">
                                        Scheduled Time
                                      </Label>
                                      <p className="label-title">
                                        {moment(data.intime).format(
                                          "Y-MM-DD h:mm:ss a"
                                        )}
                                      </p>
                                    </Col>
                                    <Col lg="3">
                                      <Label className="label-headding">
                                        Sender Id
                                      </Label>
                                      <p className="label-title">
                                        {data.sender}
                                      </p>
                                    </Col>
                                    <Col lg="4">
                                      <Label className="label-headding">
                                        Campaign Type
                                      </Label>
                                      <p className="label-title">
                                        {data.msgType}
                                      </p>
                                    </Col>
                                  </Row>
                                  <Row className="bottom-part mt-2">
                                    <Col>
                                      <p>
                                        Sent <span>{data.inserted}</span>
                                      </p>
                                    </Col>
                                    <Col>
                                      <p>
                                        Success <span>{data.submitted}</span>
                                      </p>
                                    </Col>
                                    <Col>
                                      <p>
                                        Delivered <span>{data.delivered}</span>
                                      </p>
                                    </Col>
                                    <Col>
                                      <p>
                                        Error <span>{data.error}</span>
                                      </p>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                        {/* <Col lg="6" className="">
                        <Card>
                        <CardHeader>
                          <Row>
                          <Col lg="8">
                          <h3 className="mb-0">239d9fr8vdkotilingam</h3>
                          <p><span>Manual</span> - Dear parent Kindly</p>
                          </Col>
                          <Col lg="4">
                          <Badge color="danger">View Detailed CRDs</Badge>
                          </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                        <Row>
                          <Col lg="5">
                          <Label className="label-headding">Scheduled Time</Label>
                          <p className="label-title">2023-07-12 12:00:00</p>
                          </Col>
                          <Col lg="3">
                          <Label className="label-headding" >Sender Id</Label>
                          <p className="label-title">GPRHSH</p>

                          </Col>
                          <Col lg="4">
                          <Label className="label-headding" >Campaign Type</Label>
                          <p className="label-title">Text Message</p>

                          </Col>
                          </Row>
                          <Row className="bottom-part mt-2">
                            <Col><p>Destinations <span>2</span></p></Col>
                            <Col><p>Sent <span>2</span></p></Col>
                            <Col><p>Success <span>2</span></p></Col>
                            <Col><p>Delivered <span>2</span></p></Col>
                            <Col><p>Error <span>2</span></p></Col>
                            
                          </Row>
                        </CardBody>
                      </Card>
                        </Col>
                        <Col lg="6" className="">
                        <Card>
                        <CardHeader>
                          <Row>
                          <Col lg="8">
                          <h3 className="mb-0">239d9fr8vdkotilingam</h3>
                          <p><span>Manual</span> - Dear parent Kindly</p>
                          </Col>
                          <Col lg="4">
                          <Badge color="danger">View Detailed CRDs</Badge>
                          </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                        <Row>
                          <Col lg="5">
                          <Label className="label-headding">Scheduled Time</Label>
                          <p className="label-title">2023-07-12 12:00:00</p>
                          </Col>
                          <Col lg="3">
                          <Label className="label-headding" >Sender Id</Label>
                          <p className="label-title">GPRHSH</p>

                          </Col>
                          <Col lg="4">
                          <Label className="label-headding" >Campaign Type</Label>
                          <p className="label-title">Text Message</p>

                          </Col>
                          </Row>
                          <Row className="bottom-part mt-2">
                            <Col><p>Destinations <span>2</span></p></Col>
                            <Col><p>Sent <span>2</span></p></Col>
                            <Col><p>Success <span>2</span></p></Col>
                            <Col><p>Delivered <span>2</span></p></Col>
                            <Col><p>Error <span>2</span></p></Col>
                            
                          </Row>
                        </CardBody>
                      </Card>
                        </Col>
                        <Col lg="6" className="">
                        <Card>
                        <CardHeader>
                          <Row>
                          <Col lg="8">
                          <h3 className="mb-0">239d9fr8vdkotilingam</h3>
                          <p><span>Manual</span> - Dear parent Kindly</p>
                          </Col>
                          <Col lg="4">
                          <Badge color="danger">View Detailed CRDs</Badge>
                          </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                        <Row>
                          <Col lg="5">
                          <Label className="label-headding">Scheduled Time</Label>
                          <p className="label-title">2023-07-12 12:00:00</p>
                          </Col>
                          <Col lg="3">
                          <Label className="label-headding" >Sender Id</Label>
                          <p className="label-title">GPRHSH</p>

                          </Col>
                          <Col lg="4">
                          <Label className="label-headding" >Campaign Type</Label>
                          <p className="label-title">Text Message</p>

                          </Col>
                          </Row>
                          <Row className="bottom-part mt-2">
                            <Col><p>Destinations <span>2</span></p></Col>
                            <Col><p>Sent <span>2</span></p></Col>
                            <Col><p>Success <span>2</span></p></Col>
                            <Col><p>Delivered <span>2</span></p></Col>
                            <Col><p>Error <span>2</span></p></Col>
                            
                          </Row>
                        </CardBody>
                      </Card>
                        </Col>
                        <Col lg="6" className="">
                        <Card>
                        <CardHeader>
                          <Row>
                          <Col lg="8">
                          <h3 className="mb-0">239d9fr8vdkotilingam</h3>
                          <p><span>Manual</span> - Dear parent Kindly</p>
                          </Col>
                          <Col lg="4">
                          <Badge color="danger">View Detailed CRDs</Badge>
                          </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                        <Row>
                          <Col lg="5">
                          <Label className="label-headding">Scheduled Time</Label>
                          <p className="label-title">2023-07-12 12:00:00</p>
                          </Col>
                          <Col lg="3">
                          <Label className="label-headding" >Sender Id</Label>
                          <p className="label-title">GPRHSH</p>

                          </Col>
                          <Col lg="4">
                          <Label className="label-headding" >Campaign Type</Label>
                          <p className="label-title">Text Message</p>

                          </Col>
                          </Row>
                          <Row className="bottom-part mt-2">
                            <Col><p>Destinations <span>2</span></p></Col>
                            <Col><p>Sent <span>2</span></p></Col>
                            <Col><p>Success <span>2</span></p></Col>
                            <Col><p>Delivered <span>2</span></p></Col>
                            <Col><p>Error <span>2</span></p></Col>
                            
                          </Row>
                        </CardBody>
                      </Card>
                        </Col> */}
                      </Row>
                    </Col>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </>
  );
};

export default Reportssms;
